import { store } from '../store/index'
import webviewLibraryVersion from '../../build/webview-version.json'
import deviceDetect from 'mobile-device-detect'

import TextBubble from '../core/components/TextBubble'

var requestJson = {}

const context = (function () {
  var userContext = createUserContext()
  var platformContext = createUserPlatformContext()
  var deviceContext = createUserDeviceContext()
  var extraContext
  var features

  /****************************************************/

  /* Update Context  */

  /****************************************************/

  var updateContext = function (context) {
    if (context) {
      if (context.device) {
        // console.log('deviceContext before update:', deviceContext)
        deviceContext = $jq.extend({}, deviceContext, context.device)
        // console.log('deviceContext after update:', deviceContext)
      }
      if (context.platform) {
        // console.log('platformContext before update:', platformContext)
        platformContext = $jq.extend({}, platformContext, context.platform)
        // console.log('platformContext after update:', platformContext)
      }
      if (context.user) {
        // console.log('userContext before update:', userContext)
        userContext = $jq.extend({}, userContext, context.user)
        // console.log('userContext after update:', userContext)
      }
      if (context.extra) {
        // console.log('extraContext before update:', extraContext)
        extraContext = $jq.extend({}, extraContext, context.extra)
        // console.log('extraContext after update:', extraContext)
      }
      if (context.features) {
        features = $jq.extend({}, features, context.features)
      }
      if (context.api_version) {
        // console.log('api_version before update:', store.state.api_version)
        store.state.api_version = context.api_version
        // console.log('api_version after update:', store.state.api_version)
      }
    }

    var updatedContext = createContext.call(this)
    // console.log('updatedContext', updatedContext)
    return updatedContext
  }

  /****************************************************/

  /* Remove Extra Context  */

  /****************************************************/

  const removeExtraContext = () => {
    extraContext = false
  }

  /****************************************************/

  /* Create User Device Context  */

  /****************************************************/

  function createUserDeviceContext () {
    if (!deviceContext) {
      deviceContext = {
        os: `${deviceDetect.osName} - ${deviceDetect.osVersion}`,
        model: `${deviceDetect.browserName} - ${deviceDetect.browserVersion}`,
        type: deviceDetect.isMobile ? 'mobile' : 'web',
        id: ''
      }
    }
    return deviceContext
  }

  /****************************************************/

  /* Create User Platform Context  */

  /****************************************************/

  function createUserPlatformContext () {
    if (!platformContext) {
      platformContext = {
        name: 'web',
        conversation_id: '',
        session_id: null,
        version: webviewLibraryVersion.version + ' - build ' + webviewLibraryVersion.build
      }
    }
    return platformContext
  }

  /****************************************************/

  /* Create User Context  */

  /****************************************************/

  function createUserContext (options) {
    if (!userContext) {
      userContext = {
      // "time_zone": getUserTimezone()
        meta_fields: [],
        time_zone: 'America/New_York'
      }
    }
    userContext.session_id = store.getters.getKaiSessionId
    return userContext
  }

  /****************************************************/

  /* Create Features Context  */

  /****************************************************/

  const createFeaturesContext = (options) => {
    if (!features) {
      features = {}
    }
    const disallowedFeatures = []
    if (!store.state.useAvatar && Kai.API.isApiVersionAtLeast('4.1.2')) {
      disallowedFeatures.push('message_contents.avatar')
    }

    if (disallowedFeatures.length > 0) {
      features.disallowed = disallowedFeatures
    }

    return features
  }

  /****************************************************/

  /* Create Content  */

  /****************************************************/

  const createContext = function (options) {
    const data = {
      context: {
        device: createUserDeviceContext.call(this),
        platform: createUserPlatformContext.call(this),
        user: createUserContext.call(this),
        api_version: store.state.api_version
      }
    }

    features = createFeaturesContext.call(this)
    if (!$jq.isEmptyObject(features)) {
      data.context.features = features
    }

    if (extraContext) {
      data.context.extra = extraContext
    }

    checkForMissingCapiContextFields(data.context)

    return data
  }

  /****************************************************/

  /* Build Request Context Object  */

  /****************************************************/

  const buildRequestContextObject = function () {
    requestJson = createContext.call(this)
    return requestJson
  }

  /****************************************************/

  /* Create Start Session Event RequestJson           */

  /****************************************************/
  const createStartSessionEventRequestJson = function (option) {
    const data = {
      ...createContext.call(this, this.options),
      type: 'START_SESSION',
      payload: {}
    }
    return data
  }

  /****************************************************/

  /* Create Enter Token Event RequestJson  */

  /****************************************************/

  const createEnterTokenEventRequestJson = function (options, token) {
    let data
    if (token) {
      data = {
        ...createContext.call(this, this.options),
        type: 'ENTER_TOKEN',
        payload: {
          token: token
        }
      }
      return data
    } else {
      if (Kai.API.getCurrentServerConfig().userToken) {
        data = {
          ...createContext.call(this, this.options),
          type: 'ENTER_TOKEN',
          payload: {
            token: Kai.API.getCurrentServerConfig().userToken
          }
        }
        return data
      } else {
        data = {
          ...createContext.call(this, this.options),
          type: 'ENTER_TOKEN',
          payload: {
            token: ''
          }
        }
        return data
      }
    }
  }

  /****************************************************/

  /* Create Auth Pass Thru Event Request Json  */

  /****************************************************/

  const createAuthPassThruEventRequestJson = function (options, metaFieldsArray) {
    if (metaFieldsArray) {
      const data = {
        ...createContext.call(this, this.options),
        type: 'AUTH_PASSTHRU',
        payload: {
          meta_fields: metaFieldsArray
        }
      }
      return data
    }
  }

  /****************************************************/

  /* Create Process OAuth Code Event RequestJson  */

  /****************************************************/

  const createProcessOAuthCodeEventRequestJson = function (options, token) {
    if (token) {
      const data = {
        ...createContext.call(this, this.options),
        type: 'PROCESS_OAUTH_AUTH_CODE',
        payload: {
          auth_code: token
        }
      }
      return data
    }
  }

  /****************************************************/

  /* Create Generic Event RequestJson  */

  /****************************************************/

  const createGenericEventRequestJson = function (options, type, metaFieldsArray) {
    if (metaFieldsArray) {
      const data = {
        ...createContext.call(this, this.options),
        type: type,
        payload: {
          meta_fields: metaFieldsArray
        }
      }
      return data
    }
  }

  /****************************************************/

  /* Create Intent Request Json */

  /****************************************************/

  const createIntentRequestJson = function (options) {
    const data = {
      ...createContext.call(this, this.options),
      type: 'INTENT'
    }

    return data
  }

  /****************************************************/

  /* Create Autocomplete Request Json */

  /****************************************************/

  const createAutocompleteRequestJson = function (options) {
    const data = {
      ...createContext.call(this, this.options),
      type: 'AUTO_COMPLETE'
    }

    return data
  }

  /****************************************************/

  /* Create History Request Json */

  /****************************************************/

  const createHistoryRequestJson = function (options) {
    const data = {
      ...createContext.call(this, this.options),
      type: 'GET_SESSION_TRANSCRIPT',
      payload: {}
    }

    return data
  }

  /****************************************************/

  /* Create Session Logout Request Json */

  /****************************************************/

  const createSessionLogoutRequestJson = function (options) {
    const data = {
      ...createContext.call(this, this.options),
      type: 'LOGOUT'
    }

    return data
  }

  /****************************************************/

  /* Create Live Chat Related Requests Json data  */

  /****************************************************/

  const createLiveChatSendCustomerStateRequest = function (options, isUserTyping) {
    const data = {
      ...createContext.call(this, this.options),
      type: 'LIVE_CHAT_SEND_CUSTOMER_STATE',
      payload: {
        is_typing: isUserTyping || false
      }
    }
    return data
  }

  const createLiveChatEndSessionRequest = function (options) {
    const data = {
      ...createContext.call(this, this.options),
      type: 'LIVE_CHAT_END_SESSION'
    }

    return data
  }

  const createLiveChatContactBackPhoneRequest = function (options, phoneNumber) {
    const data = {
      ...createContext.call(this, this.options),
      type: 'LIVE_CHAT_CONTACT_BACK',
      payload: {
        type: 'PHONE',
        phone_number: phoneNumber || null
      }
    }

    return data
  }

  /****************************************************/

  /* Create Get Theme Variables Event RequestJson           */

  /****************************************************/
  const createThemeVariablesEventRequestJson = function (option) {
    const data = {
      ...createContext.call(this, this.options),
      type: 'GET_UI_CONFIGURATION'
    }
    return data
  }

  /****************************************************/

  /* Display CAPI context missing field message       */

  /****************************************************/

  const checkForMissingCapiContextFields = (context) => {
    const missingDeviceType = context && context.device && (context.device.type === undefined || context.device.type.length === 0)
    const missingPlatformUserID = context && context.platform && (context.platform.user_id === undefined || context.platform.user_id.length === 0)
    if (missingDeviceType || missingPlatformUserID) {
      if (!store.state.capiContextOngoingError) {
        // display the error messages in the chat only first time the error occurred.
        Kai.Core.typingIndicator(false)
        if (missingDeviceType) {
          displayMissingCapiContextFieldMessage('device.type')
        }
        if (missingPlatformUserID) {
          displayMissingCapiContextFieldMessage('platform.user_id')
        }
        const capiContextAdditionalInfo = "Please refer to the <a href='https://docs.kasisto.com/4.3/webview#getting-started'>developer documentation</a> for more info."
        Kai.Core.addMessageContent('kai-core-components', capiContextAdditionalInfo, TextBubble, 'kai-left', true)
        store.dispatch('actionInputMessage', '')
      }
      store.state.capiContextOngoingError = true
      throw new Error('Missing CAPI Context field(s).')
    } else {
      store.state.capiContextOngoingError = false
    }
  }

  const displayMissingCapiContextFieldMessage = (fieldName) => {
    const capiContextMissingFieldError = 'Error - Configure the following field in Kasisto Conversational API context: <b>' + fieldName + '</b>'
    Kai.Core.addMessageContent('kai-core-components', capiContextMissingFieldError, TextBubble, 'kai-left', true)
  }

  /****************************************************/

  /* Create Start Session Event RequestJson           */

  /****************************************************/
  var createUIEventRequestJson = function (type, jsonPayload) {
    var data = {
      ...createContext.call(this),
      type: 'UI_EVENT',
      payload: {
        type: type,
        payload: jsonPayload
      }
    }
    return data
  }

  /****************************************************/

  /****************************************************/

  /* Create Custom Livechat Request                   */

  /****************************************************/
  var createCustomLivechatRequest = function (jsonPayload) {
    var data = {
      ...createContext.call(this),
      type: 'LIVE_CHAT_REQ_CUSTOM',
      payload: jsonPayload
    }
    return data
  }

  /****************************************************/

  return {
    createContext,
    updateContext,
    removeExtraContext,
    buildRequestContextObject,
    createStartSessionEventRequestJson,
    createEnterTokenEventRequestJson,
    createAuthPassThruEventRequestJson,
    createProcessOAuthCodeEventRequestJson,
    createGenericEventRequestJson,
    createHistoryRequestJson,
    createSessionLogoutRequestJson,
    createLiveChatSendCustomerStateRequest,
    createLiveChatEndSessionRequest,
    createLiveChatContactBackPhoneRequest,
    createThemeVariablesEventRequestJson,
    createIntentRequestJson,
    createAutocompleteRequestJson,
    checkForMissingCapiContextFields,
    displayMissingCapiContextFieldMessage,
    createUIEventRequestJson,
    createCustomLivechatRequest
  }
}())// End Core

// Export Core
export default {
  context
}
